import Logo from 'common/Components/Logo';
import Layout from 'common/Layouts';
import { useTranslation } from 'react-i18next';
import FormLogin from './components/FormLogin';

export const DesktopLogin = () => {
  const { t } = useTranslation();

  const getTitle = () => {
    const brokerName = t(
      `BrokerCode_${window.api?.BROKER_CODE}.FormSide.LogInText`
    );
    return brokerName;
  };

  return (
    <Layout title={getTitle()}>
      <Logo />
      <FormLogin />
    </Layout>
  );
};
